export default {
    mounted(el) {
        // Find the input element. If 'el' is a wrapper (like BFormInput), search inside it.
        const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
        
        if (input) {
            input.addEventListener('focus', function() {
                // If the value is '0', select the text so typing will replace it
                if (this.value === '0' || Number(this.value) === 0) {
                    this.select();
                }
            });
        }
    }
};
